<div class="p-3">
  <div class="flex justify-between">
    <div class="flex w-[100%]">
      <div class="box">
        <label>Number Patients</label>
        <div>{{ schedules?.patientsCount }}</div>
      </div>
      <div class="box">
        <label>Treatment Mins</label>
        <div>{{ schedules?.billedMinutes }}</div>
      </div>
      <div class="box">
        <label>Labour Hours</label>
        <div>{{ schedules?.labourHours }}</div>
      </div>
    </div>
    <div class="flex justify-end items-start" *ngIf="schedules?.agendaDetails && schedules.agendaDetails.length > 0">
      <thera-button
        [config]="{ variant: buttonVariant.PRIMARY, text: checkIsPrintInProgress() ? 'Generating report…' : 'Download schedule' }"
        [disabled]="checkIsPrintInProgress()"
        (click)="printScheduleReport()"
      ></thera-button>
    </div>
  </div>
  
  <div *ngIf="schedules?.agendaDetails && schedules.agendaDetails.length > 0;else no_messages"
    class="schedule-list pt-3 overflow-y-scroll">
    <div class="schedule" *ngFor="let schedule of schedules?.agendaDetails">
      <div class="limited-text" [title]="schedule.patientName">
        <a (click)="routeToPatientProfile(schedule.patientId)">
          {{ schedule.patientName | slice:0:36 }}
        </a>
      </div>
      <div>{{ schedule.discipline }}</div>
      <div class="limited-text" [attr.title]="schedule.room !== null ? schedule.room : null">
        {{ schedule.room ? (schedule.room | slice:0:20) : emDash }}
      </div>
      <div class="limited-text" [attr.title]="schedule.payorName !== null ? schedule.payorName : null">
        {{ schedule.payorName ? (schedule.payorName | slice:0:20) : emDash }}
      </div>
      <div>{{ schedule.mode }}</div>
      <div>{{ schedule.agendaMins ?? emDash}}</div>
      <div>{{ schedule.timeIn ? (schedule.timeIn | date : "shortTime" ) : emDash}}</div>
    </div>
  </div>
  <ng-template #no_messages>
    <div class="messages-container centered-text">
      No New Appointments
    </div>
  </ng-template>
</div>